import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { HIGHLIGHT_COLOR, ICON_SELECTED } = constants;

let styles = {
  base: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start'
  },
  dropdown: {
    position: 'relative',
    display: 'inline-block'
  },
  dropdownCompact: {
    justifyContent: 'start'
  },
  dropdownText: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  dropdownWithMenu: {
    cursor: 'pointer'
  },
  text: {
    paddingRight: 10,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flexGrow: 1
  },
  textCompact: {
    paddingRight: 10,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flexGrow: 0
  },
  icon: {
    flexShrink: 0,
    fontWeight: 'bold',
    fontSize: '13px !important',
    marginTop: 2
  },
  iconBlue: {
    color: ICON_SELECTED
  },
  ul: {
    visibility: 'hidden',
    opacity: 0,
    listStyle: 'none',
    position: 'absolute',
    backgroundColor: 'white',
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
    borderRadius: 8,
    zIndex: 10,
    marginTop: 8,
    width: 250,
    padding: '10px 0',
    transition:
      'all 0.2s ease-in-out 0s, visibility 0s linear 0.2s, z-index 0s linear 0.01s',
    ':before': {
      content: `''`,
      width: 0,
      height: 0,
      position: 'absolute',
      borderLeft: '7px solid transparent',
      borderRight: '7px solid transparent',
      borderBottom: '7px solid white',
      left: 73,
      top: -7
    }
  },
  ulshow: {
    visibility: 'visible',
    opacity: 1,
    zIndex: 10,
    transform: 'translateY(0%)',
    transitionDelay: '0s, 0s, 0.2s'
  },
  items: {
    maxHeight: 168,
    overflowY: 'auto'
  },
  itemsSearch: {
    maxHeight: 111
  },
  li: {
    fontSize: '1em',
    padding: 12,
    fontWeight: 500,
    color: 'black',
    textDecoration: 'none',
    ':hover': {
      backgroundColor: HIGHLIGHT_COLOR,
      color: 'white'
    }
  },
  search: {
    padding: '0 12px 8px',
    marginBottom: -20,
    ':hover': {
      backgroundColor: 'white'
    }
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/dropdown/Dropdown.styles.js